/** Pure decision for where the Facebook button shows (2026-09-18) — no Capacitor imports, Jest-tested. */
import { versionAtLeast } from './shellVersionCore';

export const FACEBOOK_MIN_SHELL = '1.0.14';
export type FacebookButtonMode = 'web' | 'native' | null;

export function facebookButtonMode(i: { enabled: boolean; native: boolean; inAppBrowser: boolean; shellVersion: string | null; parentGateNeeded: boolean }): FacebookButtonMode {
  if (!i.enabled) return null;
  if (!i.native) return i.inAppBrowser ? 'web' : null;           // the open web keeps Google/Apple only
  if (i.parentGateNeeded) return null;                             // Play Families rule, like Google
  return versionAtLeast(i.shellVersion, FACEBOOK_MIN_SHELL) ? 'native' : null;
}
